export default function Privacy() {
  return (
    <div className="py-20 lg:py-28" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-6">
        <p className="label-eyebrow mb-5">Privacy Policy</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.0]">
          We can&apos;t leak what we don&apos;t collect.
        </h1>
        <p className="mt-6 text-muted-foreground">Last updated: February 2026</p>

        <div className="mt-12 prose-style space-y-10 text-foreground/90 leading-relaxed">
          <Block title="The short version">
            <p>AVault stores your vault on your device. We don&apos;t run servers that hold your secrets. We don&apos;t collect telemetry. We don&apos;t share data with third parties.</p>
          </Block>
          <Block title="What we don't collect">
            <ul className="list-disc pl-5 space-y-2">
              <li>Your master password or any data derived from it</li>
              <li>Your vault contents (logins, notes, cards, identities, documents)</li>
              <li>Per-item read/write events</li>
              <li>Crash dumps that contain memory regions</li>
            </ul>
          </Block>
          <Block title="What we do collect">
            <p>Only what&apos;s necessary to deliver the marketing site and support requests:</p>
            <ul className="list-disc pl-5 space-y-2 mt-3">
              <li>Contact form submissions (name, email, message) — used only to reply.</li>
              <li>Anonymous, aggregated visit metrics from this website (no fingerprinting).</li>
              <li>Pro license records (email, plan, billing identifier) — handled by our payment processor.</li>
            </ul>
          </Block>
          <Block title="Your rights">
            <p>Email <span className="font-mono">privacy@avault.app</span> at any time to request deletion or export of any data tied to your contact submissions or Pro license.</p>
          </Block>
          <Block title="Changes">
            <p>If we update this policy, the change date above will be updated and we&apos;ll notify Pro users by email. Material changes won&apos;t be retroactive.</p>
          </Block>
        </div>
      </div>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <section>
      <h2 className="font-heading text-2xl font-bold tracking-tight mb-3">{title}</h2>
      <div className="text-muted-foreground">{children}</div>
    </section>
  );
}
